import React from 'react'
import { Link } from "react-router-dom";
import A4Table from './A4Table';

const Comparison = ({ dates }) => {
  const startMonth = dates[0].toLocaleString('gb', { month: 'long' });
  const startYear = dates[0].getFullYear();
  const endMonthFree = dates[5].toLocaleString('gb', { month: 'long' });
  const endMonth = dates[11].toLocaleString('gb', { month: 'long' });
  const endYearFree = dates[5].getFullYear();
  const endYear = dates[11].getFullYear();
  return ( 
    <div id="comparison">
      <table className="comparison-table">
        <thead>
          <tr>
            <th></th>
            <th>Carpe Diem Calendar <span className="light">Free</span></th>
            <th>Carpe Diem Calendar <span className="light">Freestyle</span></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Duration</td>
            <td>6 months</td>
            <td>12 months</td>
          </tr>
          <tr>
            <td>Date span</td>
            <td>{startMonth} {startYear}–{endMonthFree} {endYearFree}</td>
            <td>{startMonth} {startYear}–{endMonth} {endYear}</td>
          </tr>
          <tr>
            <td>PDF size</td>
            <td>Single-sided A4</td>
            <td>Double-sided A4</td>
          </tr>
          <tr>
            <td>A4 Frontside</td>
            <td><A4Table type="front" dates={dates}/></td>
            <td><A4Table type="front" dates={dates}/></td>
          </tr>
          <tr>
            <td>A4 Backside</td>
            <td>N/A</td>
            <td><A4Table type="back" dates={dates}/></td>
          </tr>
          <tr>
            <td>Price</td>
            <td>Free</td>
            <td>£3</td>
          </tr>
          <tr>
            <td>Colour options</td>
            <td>
              <span className="circle forest"></span>
            </td>
            <td>
              <span className="circle forest"></span>
              <span className="circle violet"></span>
              <span className="circle skyblue"></span>
              <span className="circle crimson"></span>
              <span className="circle gold"></span>
              <span className="circle purple"></span>
            </td>
          </tr>

          <tr>
            <td></td>
            <td><Link to="/download/QkaQHG5U1yhPGQBa4bX3">Download</Link></td>
            <td><a href="#colourways">Customise</a></td>
          </tr>
        </tbody>
      </table>
    </div>
   );
}
 
export default Comparison;